export const ERROR_NAME = 'InstrumentationError'

export class InstrumentationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = ERROR_NAME
  }
}

export default InstrumentationError
